var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2_00000172430583702779594070000014119145379897554817_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 98.4 98.4",
    style: {
      enableBackground: "new 0 0 98.4 98.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#125FDE;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1307"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_309",
    className: "st0",
    cx: 49.2,
    cy: 49.2,
    r: 49.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.2,64.5c-13,0-25.1-5.7-32.9-15.3c7.7-9.6,19.9-15.3,32.9-15.3s25.2,5.7,33,15.3 C74.4,58.8,62.2,64.5,49.2,64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.2,40.9c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3s8.3-3.7,8.3-8.3S53.8,40.9,49.2,40.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSelectedIcon);
export default __webpack_public_path__ + "static/media/eyeSelectedIcon.27462e6cf75a91442efd6ea394db0a27.svg";
export { ForwardRef as ReactComponent };